import axios from 'axios';

export const urlBackend = "https://api.meantto.io";

export const postRequest = async (url, data) => {
  const response = await axios.post(`${urlBackend}/${url}`, data);
  return response;
};

export const postRequestMeantto = async (url, dataUser, data) => {
  const dataRequest = {
    email: dataUser.email,
    password: dataUser.password,
    token: dataUser.token,
    data: data
  };

  const response = await axios.post(`${urlBackend}/${url}`, dataRequest);
  return response;
};

export const putRequestMeantto = async (url, dataUser, data) => {
  const dataRequest = {
    email: dataUser.email,
    password: dataUser.password,
    token: dataUser.token,
    data: data
  };

  const response = await axios.put(`${urlBackend}/${url}`, dataRequest);
  return response;
};

export const patchRequestMeantto = async (url, dataUser, data) => {
  const dataRequest = {
    email: dataUser.email,
    password: dataUser.password,
    token: dataUser.token,
    data: data
  };

  const response = await axios.patch(`${urlBackend}/${url}`, dataRequest);
  return response;
};

export const patchRequestCollaborators = async (url, dataUser, data) => {
  const dataRequest = {
    email: dataUser.email,
    user: dataUser.user,
    token: dataUser.token,
    data: data
  };

  const response = await axios.patch(`${urlBackend}/${url}`, dataRequest);
  return response;
};

export const patchRequestCollaborator = async (url, dataUser, data) => {
  const dataRequest = {
    email: dataUser.email,
    password: dataUser.password,
    token: dataUser.token,
    typeAccess: dataUser.typeAccess,
    data: data
  };

  const response = await axios.patch(`${urlBackend}/${url}`, dataRequest);
  return response;
};